module.exports = __webpack_public_path__ + "media/images/icons/success-icon-green-ee3a453282475b0c016cba03328ade62.svg";